import React from 'react'
import ActivityDate from 'views/activity240903/images/title/t1.png'
import ActivityMethod from 'views/activity240903/images/title/t2.png'

function Activity() {
  return (
    <>
      <p>
        <img
          className='m:hidden'
          style={{ width: '303px' }}
          src={ActivityDate}
          alt='activity-date'
        />
        <img
          className='hidden m:block'
          style={{ width: '240px', margin: '0 auto' }}
          src={ActivityDate}
          alt='activity-date'
        />
      </p>
      <p>&nbsp;</p>
      <p>
        <span>2024/9/4(三)~2024/10/1(二) </span>
      </p>
      <p>&nbsp;</p>
      <p>
        <span>每天晚上22:00~23:59</span>
      </p>
      <p>&nbsp;</p>
      <p>
        <img
          className='m:hidden'
          style={{ width: '303px' }}
          src={ActivityMethod}
          alt='activity-award'
        />
        <img
          className='hidden m:block'
          style={{ width: '240px', margin: '0 auto' }}
          src={ActivityMethod}
          alt='activity-award'
        />
      </p>
      <p>&nbsp;</p>
      <p>
        <span>
          活動時間內將於全服開啟「抽金幣活動」，系統將於隨機時間發送免費紅包，成功開啟後皆能拿到免費金幣！所有紅包限時限量，先搶先贏，敬請玩家一同共襄盛舉！
        </span>
      </p>
      <br />
      <p>&nbsp;</p>
      <p>
        <span style={{ color: '#f5e61c' }}>※ 紅包金幣獎勵將以信件形式，在10分鐘內寄送至信箱。</span>
        <br />
        <span style={{ color: '#f5e61c' }}>
          ※ VIP卡別須達「銀卡」以上才能進行抽金幣遊戲，並依照各VIP
          提供隨機數量的免費紅包供玩家們同樂。
        </span>
        <br />
      </p>
      <p>&nbsp;</p>
      <p>
        <span>官方保有調整或修改活動規則的權益。</span>
      </p>
      <p>&nbsp;</p>
      <p>
        <span>
          <span style={{ color: '#f5e61c' }}>iOS下載：</span>
          <a
            href='https://apps.apple.com/tw/app/%E8%81%9A%E5%AF%B6online/id1563757256'
            target='_blank'
            rel='noreferrer'
          >
            點擊前往
          </a>
        </span>
        <br />
        <span>
          <span style={{ color: '#f5e61c' }}>Android下載：</span>
          <a
            href='https://play.google.com/store/apps/details?id=com.jixi.android.gbao888'
            target='_blank'
            rel='noreferrer'
          >
            點擊前往
          </a>
        </span>
      </p>
      <p>&nbsp;</p>
      <p>聚寶Online祝福您中大獎</p>
    </>
  )
}

export default Activity
